import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@store/hooks';
import { selectAuth, selectIsAuthenticated } from '@store/slices/auth';

export function RedirectIfAuthed() {
  const { initializing } = useAppSelector(selectAuth);
  const isAuthed = useAppSelector(selectIsAuthenticated);

  // <BootSplash> in AppRoutes covers the viewport while initializing.
  if (initializing) return null;

  if (isAuthed) return <Navigate to="/home" replace />;
  return <Outlet />;
}
